import { render } from "./BoardListAll.vue?vue&type=template&id=7fa0431f&scoped=true&ts=true"
import script from "./BoardListAll.vue?vue&type=script&lang=ts"
export * from "./BoardListAll.vue?vue&type=script&lang=ts"

import "./BoardListAll.vue?vue&type=style&index=0&id=7fa0431f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa0431f"]])

export default __exports__